<app-breadcrumb [title]="'Zonas de Vías Administradas'" [items]="['Pesv']"
  [active_item]="'Zonas de Vías'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="fa fa-map-signs me-2"></i>
      <h5 class="mb-0"><strong>REGISTRO DE ZONAS DE VÍAS</strong></h5>
    </div>

    <div class="card-body">
      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 1" (click)="activeTab = 1">
            <i class="fa fa-plus me-1"></i>{{ editando ? 'Editar zona' : 'Registrar zona' }}
          </button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link" [class.active]="activeTab === 2" (click)="mostrarListado()">
            <i class="fa fa-list me-1"></i>Listado de zonas
          </button>
        </li>
      </ul>

      <form *ngIf="activeTab === 1" [formGroup]="form" (ngSubmit)="guardar()">
        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-info-circle me-2"></i>
            1. Información general
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-3">
              <label class="form-label required">Vía interna: <span class="text-danger">*</span></label>
              <ng-select [items]="vias" placeholder="Seleccione una vía" bindLabel="nombreConCodigo" bindValue="id"
                formControlName="via_id">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label required">Código: <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="codigo" placeholder="ZN-001" />
            </div>

            <div class="col-md-3">
              <label class="form-label required">Tipo de zona: <span class="text-danger">*</span></label>
              <ng-select [items]="tiposZona" placeholder="Seleccione un tipo de zona" bindLabel="descripcion"
                bindValue="id" formControlName="tipo_zona">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label required">Nombre de la zona: <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="nombre"
                placeholder="Zona de cargue y descargue - Bodega 1" />
            </div>

            <div class="col-md-12">
              <label class="form-label">Descripción: <span class="text-muted">(Opcional)</span></label>
              <textarea class="form-control" rows="3" formControlName="descripcion"></textarea>
            </div>
          </div>
        </div>

        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-road me-2"></i>
            2. Características de la zona
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-3">
              <label class="form-label">Longitud (m): <span class="text-danger">*</span></label>
              <input type="number" placeholder="Ingrese la longitud en metros" class="form-control"
                formControlName="longitud_m" />
            </div>

            <div class="col-md-3">
              <label class="form-label">Ancho (m): <span class="text-danger">*</span></label>
              <input type="number" placeholder="Ingrese el ancho en metros" class="form-control"
                formControlName="ancho_m" />
            </div>

            <div class="col-md-3">
              <label class="form-label">Sentido de circulación: <span class="text-danger">*</span></label>
              <ng-select [items]="sentidosCirculacion" bindLabel="descripcion" bindValue="id"
                placeholder="Seleccione un sentido de circulación" formControlName="sentido_circulacion">
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="form-label">Velocidad máxima permitida: <span class="text-danger">*</span></label>
              <div class="input-group">
                <input type="number" placeholder="Velocidad máxima" class="form-control"
                  formControlName="velocidad_maxima_kmh" />
                <span class="input-group-text">km/h</span>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Nivel de riesgo: <span class="text-danger">*</span></label>
              <ng-select [items]="nivelesRiesgo" placeholder="Seleccione un nivel" bindLabel="descripcion"
                bindValue="id" formControlName="nivel_riesgo">
              </ng-select>
            </div>
          </div>
        </div>

        <div class="panel-section mb-4">
          <div class="panel-title">
            <i class="fa fa-map-marker me-2"></i>
            3. Ubicación y mapa
          </div>

          <div class="row g-3 mt-2">
            <div class="col-md-3">
              <label class="form-label">Latitud: <span class="text-danger">*</span></label>
              <input type="number" placeholder="Ingrese la latitud" class="form-control" formControlName="latitud"
                step="0.0001" (input)="actualizarMapa()" />
            </div>

            <div class="col-md-3">
              <label class="form-label">Longitud: <span class="text-danger">*</span></label>
              <input type="number" placeholder="Ingrese la longitud" class="form-control" formControlName="longitud"
                step="0.0001" (input)="actualizarMapa()" />
            </div>

            <div class="col-md-6">
              <label class="form-label">Mapa de ubicación: <span class="text-danger">*</span></label>
              <div class="border rounded bg-light map-box overflow-hidden">
                <iframe *ngIf="mapUrl" class="map-frame" [src]="mapUrl" title="Mapa de ubicación"></iframe>
                <div *ngIf="!mapUrl"
                  class="map-placeholder text-center text-muted d-flex align-items-center justify-content-center">
                  <span><i class="fa fa-map me-2"></i>Ingrese coordenadas válidas</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-light border text-secondary px-4"
              (click)="cancelar()">Cancelar</button>

            <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">{{ guardando ? 'Guardando...' :
              'Guardar' }}</button>
          </div>
        </div>
      </form>

      <div *ngIf="activeTab === 2">
        <div class="row mb-3 align-items-center">
          <div class="col-md-4">
            <input type="search" class="form-control" [(ngModel)]="filtro" (input)="aplicarFiltro()"
              placeholder="Buscar por código, nombre, vía o tipo..." />
          </div>
        </div>

        <div *ngIf="cargandoListado" class="text-center py-4">
          <span class="spinner-border text-primary"></span>
          <p class="mt-2 mb-0">Cargando zonas...</p>
        </div>

        <div *ngIf="!cargandoListado" class="table-responsive">
          <table id="tblViasZonas" class="table table-bordered table-hover align-middle">
            <thead class="bg-primary text-white">
              <tr>
                <th class="text-center">CÓDIGO</th>
                <th class="text-center">VÍA</th>
                <th class="text-center">NOMBRE</th>
                <th class="text-center">TIPO DE ZONA</th>
                <th class="text-center">SENTIDO CIRCULACIÓN</th>
                <th class="text-center">LONGITUD (m)</th>
                <th class="text-center">VEL. MÁX. (km/h)</th>
                <th class="text-center">NIVEL DE RIESGO</th>
                <th class="text-center">ESTADO</th>
                <th class="text-center">ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let zona of zonasFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                <td class="text-center">{{ zona.codigo }}</td>
                <td class="text-center">{{ nombreVia(zona.via_id) }}</td>
                <td class="text-uppercase">{{ zona.nombre }}</td>
                <td class="text-center">{{ zona.TipoZonaViasData?.descripcion }}</td>
                <td class="text-center">{{ zona.SentidoCirculacionViasData?.descripcion }}</td>
                <td class="text-center">{{ zona.longitud_m }}</td>
                <td class="text-center">{{ zona.velocidad_maxima_kmh }}</td>
                <td class="text-center">
                  <span *ngIf="zona.nivel_riesgo != null" class="badge" [ngClass]="claseRiesgo(zona.nivel_riesgo)">
                    {{ zona.NivelRiesgoViasData?.descripcion }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="badge" [ngClass]="Number(zona.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                    {{ Number(zona.estado) === 1 ? 'ACTIVA' : 'INACTIVA' }}
                  </span>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-outline-primary me-1 rounded-pill btn-rounded"
                    (click)="editarZona(zona)" [disabled]="Number(zona.estado) !== 1" title="Editar">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-warning me-1 rounded-pill btn-rounded"
                    (click)="verRiesgos(zona)" title="Ver riesgos de la zona">
                    <i class="fa fa-exclamation-triangle"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-info me-1 rounded-pill btn-rounded"
                    (click)="verInspecciones(zona)" title="Ver inspecciones de la zona">
                    <i class="fa fa-search"></i>
                  </button>
                  <button type="button" class="btn btn-sm rounded-pill btn-rounded"
                    [ngClass]="Number(zona.estado) === 1 ? 'btn-outline-danger' : 'btn-outline-success'"
                    (click)="cambiarEstado(zona)" [title]="Number(zona.estado) === 1 ? 'Inactivar' : 'Activar'">
                    <i class="fa" [ngClass]="Number(zona.estado) === 1 ? 'fa-ban' : 'fa-check'"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!zonasFiltradas.length">
                <td colspan="10" class="text-center text-muted py-4">No hay zonas registradas.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4" *ngIf="zonasFiltradas.length > 0">
          <div class="d-flex align-items-center">
            <label class="me-2">Mostrar:</label>
            <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>
          <div class="text-center flex-grow-1">
            Total Registros: <a class="badge badge-primary"><b>{{ zonasFiltradas?.length || 0 }}</b></a>
          </div>
          <div class="text-end paginador-personalizado">
            <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
              [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
          </div>
        </div>

        <div class="btn-showcase text-center mt-4" *ngIf="zonasFiltradas.length">
          <button type="button" class="btn btn-outline-success-2x me-2" (click)="exportarExcel()">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>
          <button type="button" class="btn btn-outline-danger-2x" (click)="exportarPdf()">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>